<div class="flex flex-col gap-1">
  <div class="flex items-center justify-end gap-2">
    @if (compact) {
      <div
        *ngIf="name"
        class="mat-caption flex-1 truncate"
        [matTooltip]="tooltip"
        [matTooltipDisabled]="!tooltip"
      >
        {{ name }}
      </div>

      <div
        class="mat-caption price flex items-center"
        [ngClass]="{ disabled: disabled, invalid: priceCtrl.invalid }"
      >
        @if (!disabled) {
          <div class="flex items-center gap-1">
            $
            <input
              matInput
              type="number"
              class="mr-0.5"
              min="0"
              step="0.01"
              autocomplete="off"
              [formControl]="priceCtrl"
              (keyup.enter)="$event.target.blur()"
            />
          </div>
        } @else {
          ${{ priceCtrl.value }}
        }

        @if (!disabled) {
          @if (canReset$ | async) {
            <button
              mat-icon-button
              class="icon-sm opacity-50"
              [disabled]="resetDisabled()"
              [matTooltip]="resetButtonTooltip()"
              (click)="resetPrice()"
            >
              <mat-icon>restart_alt</mat-icon>
            </button>
          } @else {
            <span class="w-5 flex-1"></span>
          }

          @if (!disableDelete) {
            <button
              mat-icon-button
              class="icon-sm opacity-50"
              color="warn"
              [matTooltip]="'Delete ' + name"
              (click)="basePriceDeleted.emit()"
            >
              <mat-icon>close</mat-icon>
            </button>
          }
        }
      </div>

      @if (pricingRule$ | async; as pricingRule) {
        <pr-service-pricing-rule-item-select
          *ngIf="isVariable$ | async"
          [pricingRule]="pricingRule"
          [disabled]="disabled"
          (updateSelectedRuleItem)="onPricingRuleChange($event)"
        />
      }
    } @else {
      <div
        *ngIf="name"
        class="flex-1 truncate"
        [matTooltip]="tooltip"
        [matTooltipDisabled]="!tooltip"
      >
        {{ name }}
      </div>
      <div
        class="flex"
        [ngClass]="{ disabled: disabled, invalid: priceCtrl.invalid }"
      >
        @if (!disabled) {
          <mat-form-field
            class="price-form-field compact"
            subscriptSizing="dynamic"
            appearance="outline"
          >
            <mat-label>{{ name ?? 'Base Price' }}</mat-label>
            <span matTextPrefix>$&nbsp;</span>
            <input
              matInput
              type="number"
              class="mr-1.5"
              min="0"
              step="0.01"
              autocomplete="off"
              [formControl]="priceCtrl"
              (keyup.enter)="$event.target.blur()"
            />

            <div matSuffix class="flex items-end">
              @if (canReset$ | async) {
                <button
                  mat-icon-button
                  class="icon-sm opacity-50"
                  matTooltip="Reset to Fee Schedule price"
                  (click)="resetPrice()"
                >
                  <mat-icon>restart_alt</mat-icon>
                </button>
              } @else {
                <span class="w-6 flex-1"></span>
              }

              @if (!disableDelete) {
                <button
                  mat-icon-button
                  class="icon-sm opacity-50"
                  color="warn"
                  [matTooltip]="'Delete ' + name"
                  (click)="basePriceDeleted.emit()"
                >
                  <mat-icon>close</mat-icon>
                </button>
              }
            </div>
          </mat-form-field>
        } @else {
          ${{ priceCtrl.value }}
        }
      </div>
    }
  </div>
</div>
